import React from "react";
import { useTranslation } from "react-i18next";
import { ProjectElementType, task as taskMock } from "@planzone/dto";
import { useCreateKanbanTask } from "@planzone/view-models";

import { useMessage } from "@components/useMessage";
import { Loader } from "@common/loader";
import { useCleanUp } from "../utils";
import { Props } from "./types";
import { EnterIcon } from "@common/assets/enterIcon";

import styles from "./styles.scss";

function Form({ rootList, status, project, range, done }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, createKanbanTask } = useCreateKanbanTask();
  const [task, setTask] = React.useState({
    ...taskMock,
    activityKeyRank: -1,
    status,
  });
  const cleanUp = useCleanUp();
  const submit = () =>
    !isRequestPending &&
    createKanbanTask({
      list: rootList,
      task,
      project,
      range: range && {
        min: range.min
          ? { type: ProjectElementType.TASK, uuid: range.min.uuid }
          : null,
        max: range.max
          ? { type: ProjectElementType.TASK, uuid: range.max.uuid }
          : null,
      },
    });

  useMessage(cleanUp(done));

  return (
    <div className={styles.form}>
      <input
        className={styles.input}
        placeholder={t("kanban.taskCreation.namePlaceholder")}
        value={task.name}
        onChange={({ target }) => setTask({ ...task, name: target.value })}
        onKeyUp={({ key }) => key === "Enter" && submit()}
        autoFocus
      />
      {isRequestPending ? (
        <div className={styles.loader}>
          <Loader />
        </div>
      ) : (
        <button className={styles.button} onClick={submit}>
          {t("kanban.taskCreation.submit")}
          <EnterIcon className={styles.buttonIcon} />
        </button>
      )}
    </div>
  );
}

export { Form };
